<form [formGroup]="form" class="uploader-group">
  <div class="edit-block">
    <div class="edit-section edit-form">
      <div class="column-2">
        <div class="col">
          <div class="input-container-check-box" *ngIf="canActivate">
            <mat-checkbox
              formControlName="active"
              (change)="openActiveWasteProfileModal($event.checked)"
              class="check-box-label"
            >
              Waste Profile is set to {{ activeWPState }}
            </mat-checkbox>
          </div>
          <div class="input-container">
            <label>Internal Waste Profile Status</label>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-select formControlName="internalStatus">
                <mat-option
                  *ngFor="let option of internalStatusOptions"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="input-container">
            <label> Waste Profile Number </label>
            <mat-form-field appearance="outline">
              <input readonly matInput formControlName="number" />
            </mat-form-field>
            <mat-error class="error" *ngIf="!isValidWasteProfileNumber">
              This waste profile number already exists, please enter a new Waste
              Profile Log ID
            </mat-error>
          </div>

          <div class="input-container" formGroupName="destination">
            <label> Division Number </label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="divisionNumber" />
            </mat-form-field>
          </div>

          <div class="input-container">
            <label> Year Code</label>
            <mat-form-field appearance="outline">
              <input
                maxlength="2"
                minlength="2"
                matInput
                formControlName="yearCode"
                (keyup)="resetWasteProfileErrorState()"
              />
            </mat-form-field>
            <mat-error
              class="error"
              *ngIf="errorHandling('yearCode', 'required')"
              data-cy="yearCode-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
            <mat-error *ngIf="errorHandling('yearCode', 'pattern')"
              >Please check format of the Year
            </mat-error>
          </div>

          <div class="input-container">
            <label> Waste Profile Log ID </label>
            <mat-form-field appearance="outline">
              <input
                maxlength="5"
                matInput
                formControlName="logbookSequenceNumber"
                (focusout)="onFocusOutEvent($event)"
                (keyup)="resetWasteProfileErrorState()"
              />
            </mat-form-field>
            <mat-error
              class="error"
              *ngIf="errorHandling('logbookSequenceNumber', 'required')"
              data-cy="logbook-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
            <mat-error *ngIf="errorHandling('logbookSequenceNumber', 'pattern')"
              >Please check format of the Waste Profile Log ID
            </mat-error>
          </div>

          <div class="input-container">
            <label> TRUX Material Description </label>
            <digital-platform-trux-material-description
              formControlName="truxMaterialDescription"
            >
            </digital-platform-trux-material-description>
            <mat-error
              class="error"
              *ngIf="errorHandling('truxMaterialDescription', 'required')"
              data-cy="trux-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
          </div>

          <div class="input-container">
            <label> Expiration Date </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                disabled
                [readonly]="disableGeneratorFields"
                [matDatepicker]="picker"
                formControlName="expiryDate"
                #pickerInput
                placeholder="MM/DD/YYYY"
                (dateChange)="resetBadRawDateInput('expiryDate', pickerInput)"
              />
              <mat-datepicker-toggle
                matPrefix
                [for]="picker"
                [disabled]="disableGeneratorFields"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-error
              class="error"
              *ngIf="errorHandling('expiryDate', 'required')"
              data-cy="exp-date-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
            <mat-error
              class="error"
              *ngIf="errorHandling('expiryDate', 'afterDate')"
            >
              Invalid Date
            </mat-error>
            <mat-error class="error" *ngIf="errorHandling('expiryDate', 'max')">
              Invalid Date
            </mat-error>
            <mat-error class="error" *ngIf="errorHandling('expiryDate', 'min')">
              Invalid Date
            </mat-error>
          </div>

          <div
            class="input-container"
            *ngIf="wasteProfile?.type === 'special-waste'"
          >
            <label>Disposal Consideration</label>
            <div fxLayout="row" fxLayoutGap="20px">
              <div fxFlex="50%">
                <mat-radio-group
                  fxLayout="column"
                  formControlName="approvedDisposalConsideration"
                >
                  <mat-radio-button value="landfill">Landfill</mat-radio-button>
                  <mat-radio-button value="solidification"
                    >Solidification</mat-radio-button
                  >
                  <mat-radio-button value="biomremediation"
                    >Bioremediation</mat-radio-button
                  >
                  <mat-radio-button value="deep-well"
                    >Deep Well</mat-radio-button
                  >
                </mat-radio-group>
                <mat-checkbox formControlName="isTransferFacilityRequired">
                  Transfer Facility
                </mat-checkbox>
              </div>
            </div>
            <label>Special Waste Characteristics</label>
            <div fxLayout="row" fxLayoutGap="20px">
              <div
                fxFlex="100%"
                formGroupName="metadataCharacteristics"
                fxLayout="column"
              >
                <mat-checkbox formControlName="wetWaste"
                  >Wet Waste</mat-checkbox
                >
                <mat-checkbox formControlName="sulfur">Sulfur</mat-checkbox>
                <div *ngIf="form.get('metadataCharacteristics.sulfur').value">
                  <mat-form-field class="meta-input-width">
                    <input
                      matInput
                      placeholder="Sulfur"
                      formControlName="sulfurPpm"
                      type="number"
                    /> </mat-form-field
                  ><span class="meta-input-font">ppm</span>
                </div>
                <mat-checkbox formControlName="pfas">PFAS</mat-checkbox>
                <div *ngIf="form.get('metadataCharacteristics.pfas').value">
                  <mat-form-field class="meta-input-width">
                    <input
                      matInput
                      placeholder="PFAS"
                      formControlName="pfasPpb"
                      type="number"
                    /> </mat-form-field
                  ><span class="meta-input-font">ppb</span>
                </div>
                <mat-checkbox formControlName="heatGeneration"
                  >Heat Generation</mat-checkbox
                >
                <div
                  *ngIf="
                    form.get('metadataCharacteristics.heatGeneration').value
                  "
                >
                  <mat-form-field class="meta-input-width">
                    <input
                      matInput
                      placeholder="Heat gen"
                      formControlName="heatGenerationJg"
                      type="number"
                    /> </mat-form-field
                  ><span class="meta-input-font">J/g</span>
                  <mat-form-field class="meta-input-width">
                    <input
                      matInput
                      placeholder="Heat gen%"
                      formControlName="heatGenerationMetalOxide"
                      type="number"
                    /> </mat-form-field
                  ><span class="meta-input-font">% Metal Oxide</span>
                </div>
                <mat-checkbox formControlName="pcbs">PCBs</mat-checkbox>
                <mat-checkbox formControlName="norm">NORM</mat-checkbox>
                <mat-checkbox formControlName="tenorm">TENORM</mat-checkbox>
                <mat-checkbox formControlName="texasClass1"
                  >Texas Class 1</mat-checkbox
                >
                <mat-checkbox formControlName="californiaHazardous"
                  >California Hazardous</mat-checkbox
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="input-container-tall" *ngIf="canActivate"></div>
          <div class="input-container">
            <label> Coordinators </label>
            <digital-platform-coordinators-drop-down
              formControlName="coordinator"
            >
            </digital-platform-coordinators-drop-down>
            <mat-error
              class="error"
              *ngIf="errorHandling('coordinator', 'required')"
              data-cy="coordinator-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
          </div>
          <div class="input-container">
            <label> Sales Rep Name </label>

            <digital-platform-sales-rep-drop-down
              formControlName="salesRep"
            ></digital-platform-sales-rep-drop-down>
            <mat-error
              class="error"
              *ngIf="errorHandling('salesRep', 'required')"
              data-cy="sales-rep-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
          </div>
          <div class="input-container">
            <label> Analyst Name </label>

            <digital-platform-analysts-drop-down
              formControlName="approverName"
            ></digital-platform-analysts-drop-down>
            <mat-error
              class="error"
              *ngIf="errorHandling('approverName', 'required')"
              data-cy="analyst-required-error-message"
            >
              Please enter required information before changing the status
            </mat-error>
          </div>
        </div>
      </div>
      <div class="input-container">
        <label>Precautions, Conditions,or Limitations on Approval </label>
        <mat-form-field appearance="outline">
          <textarea
            formControlName="approvalNotes"
            matInput
            matTextareaAutosize
            matAutosizeMinRows="4"
            matAutosizeMaxRows="4"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="edit-section history-table">
      <digital-platform-internal-status-history-table
        [wasteProfile]="this.value"
      >
      </digital-platform-internal-status-history-table>
    </div>
  </div>

  <div>
    <div class="edit-block">
      <div class="edit-form edit-section">
        <div class="column-2">
          <div class="col">
            <div class="input-container" formGroupName="destination">
              <label> Landfill </label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="landfillname" />
              </mat-form-field>
            </div>
            <div formGroupName="generator">
              <div class="input-container">
                <label> Generator </label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="name" />
                  <mat-error *ngIf="generatorErrorHandling('name', 'required')">
                    Generator Name is <strong>Required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-container">
                <label> Generator Site Address </label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="generatorAddress" />
                </mat-form-field>
              </div>
            </div>

            <div class="input-container">
              <label> Generator Waste Code </label>
              <mat-form-field appearance="outline">
                <input
                  maxlength="12"
                  matInput
                  formControlName="stateApprovalWasteCode"
                />
                <mat-error
                  *ngIf="errorHandling('stateApprovalWasteCode', 'required')"
                >
                  Generator Waste Code is <strong>Required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col">
            <div class="input-container">
              <label> Waste Stream </label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="name" />
              </mat-form-field>
            </div>
            <div formGroupName="generator">
              <div class="input-container">
                <label> City </label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="city" />
                </mat-form-field>
              </div>
              <div class="input-container">
                <label> State </label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="state" />
                </mat-form-field>
              </div>
            </div>

            <div class="input-container">
              <label
                >Annual Volume
                <button
                  mat-icon-button
                  class="btn-hint"
                  matTooltip="Please do not list a range such as: 20-60 cy. Enter only the higher number"
                >
                  <mat-icon>help</mat-icon>
                </button></label
              >
              <mat-form-field appearance="outline" floatLabel="always">
                <input
                  maxlength="24"
                  matInput
                  placeholder="If a range, enter the higher number"
                  formControlName="estimatedVolume"
                />
                <mat-error *ngIf="errorHandling('estimatedVolume', 'required')">
                  Annual Volume is <strong>Required</strong>
                </mat-error>
                <mat-error *ngIf="errorHandling('estimatedVolume', 'integer')">
                  Please enter integer value
                </mat-error>
                <mat-error *ngIf="errorHandling('estimatedVolume', 'max')">
                  Value must be less than or equal to 999999999
                </mat-error>
              </mat-form-field>
            </div>

            <div class="input-container">
              <label> Volume Type </label>
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-select
                  formControlName="unitOfMeasure"
                  placeholder="Select Unit"
                >
                  <mat-option
                    *ngFor="let option of streamOptions.options"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="errorHandling('unitOfMeasure', 'required')">
                  Volume Type is <strong>Required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-section comment-log comment-div">
        <digital-platform-waste-profile-comment-log
          formControlName="commentLog"
        >
        </digital-platform-waste-profile-comment-log>
      </div>
    </div>
  </div>
  <div class="edit-block">
    <div class="edit-form edit-section">
      <div class="upload-block">
        <ng-container formArrayName="additionalAdminSupplements">
          <ng-container
            *ngFor="
              let attachment of additionalAdminSupplements.controls;
              index as i
            "
          >
            <digital-platform-additional-supplements-form
              [formControlName]="i"
              (additionalSupplementDeleted)="
                onAdditionalAdminSupplementDeleted($event)
              "
            ></digital-platform-additional-supplements-form>
          </ng-container>
        </ng-container>

        <button
          mat-button
          color="accent"
          class="semi-bold-text"
          *ngIf="showAnotherAdditionalAdminSupplements"
          (click)="addAnotherAdditionalSupplements()"
        >
          <mat-icon>add</mat-icon> Add Another Supplement
        </button>
      </div>

      <div class="upload-block">
        <ng-container formArrayName="stateInternalAdminAttachments">
          <ng-container
            *ngFor="
              let attachment of stateInternalAdminAttachments.controls;
              index as i
            "
          >
            <digital-platform-state-attachments-form
              [formControlName]="i"
              (stateAttachmentDeleted)="onStateAdminAttachmentDeleted($event)"
            >
            </digital-platform-state-attachments-form>
          </ng-container>
        </ng-container>
        <button
          mat-button
          color="accent"
          class="semi-bold-text"
          *ngIf="showAnotherAdminStateAttachments"
          (click)="addAnotherStateAdminattachments()"
        >
          <mat-icon>add</mat-icon> Add Another State Attachment
        </button>
      </div>

      <div class="upload-block thirdPartyHeight">
        <digital-platform-authorization-attachments-form
          displayMode="admin"
          formControlName="thirdPartyAuthAdminAttachment"
          (thirdPartyAttachmentDeleted)="onThirdPartyAttachmentDeleted($event)"
        >
        </digital-platform-authorization-attachments-form>
      </div>
      <div class="upload-block">
        <ng-container formArrayName="internalAdminAttachments">
          <ng-container
            *ngFor="
              let attachment of internalAdminAttachments.controls;
              index as i
            "
          >
            <digital-platform-internal-attachment-form
              [formControlName]="i"
              (internalAttachmentDeleted)="
                onInternalOnlyAttachmentDeleted($event)
              "
            >
            </digital-platform-internal-attachment-form>
          </ng-container>
        </ng-container>
        <button
          mat-button
          color="accent"
          class="semi-bold-text"
          *ngIf="showAnotherInternalOnlyAttachment"
          (click)="addAnotherInternalOnlyAttachment()"
        >
          <mat-icon>add</mat-icon> Add Another Internal Only Attachment
        </button>
      </div>
      <div class="save-attchments-button">
        <button
          mat-button
          color="accent"
          (click)="onSubmit()"
          [disabled]="!attachmentsToSave"
        >
          Save Attachments
        </button>
      </div>
    </div>
  </div>
  <div class="edit-block">
    <div class="edit-form edit-section">
      <digital-platform-waste-profile-attachments-log
        [wasteProfile]="this.value"
        (deleteAdditionalAdminSupplementLog)="deleteAttachmentLog($event)"
        (deleteStateAdminAttachmentLog)="deleteAttachmentLog($event)"
        (deleteInternalOnlyAttachmentLog)="deleteAttachmentLog($event)"
        (deleteThirdPartyAttachmentLog)="deleteAttachmentLog($event)"
      >
      </digital-platform-waste-profile-attachments-log>
    </div>
  </div>
</form>

<ng-template #activeWasteProfileDialog>
  <mat-dialog-content>
    <h2 data-testid="wp-inactive-confirmation-dialog-text" class="content">
      Set this waste profile to {{ activeTitle }}?
    </h2>
    <p *ngIf="activeTitle === 'Inactive'">
      This will prevent access to the waste profile by the customer.
    </p>
    <p *ngIf="activeTitle === 'Active'">
      This will allow access to the waste profile by the customer.
    </p>
    <button
      data-testid="wp-inactive-confirmation-dialog-close-icon-button"
      mat-icon-button
      cdkFocusInitial
      class="close"
      aria-label="Close dialog"
      color="accent"
      [disableRipple]="true"
      [mat-dialog-close]=""
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      data-testid="wp-inactive-confirmation-dialog-deny-button"
      mat-stroked-button
      (click)="deny()"
      class="deny-button"
    >
      Cancel
    </button>
    <button
      class="confirm-button"
      data-testid="wp-inactive-confirmation-dialog-confirm-button"
      mat-flat-button
      color="accent"
      (click)="confirm()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
</ng-template>
